import { IConfig } from "./Render";
export const Polygon = ({points, stroke, stroke_width, fill }:IConfig)=>
{
    return (
       <polygon points = {points} stroke={stroke} strokeWidth={stroke_width} fill={fill} ></polygon>
    );
}